import { RunAosResultComponent } from "./RunAOsResult";
import { RunAOsComponent } from "./RunAOs";
import { GetAOComponent } from "./GetAO";
import { AOHtmlComponent } from "./AOHtml";
import { CreateRunAOsComponent } from "./CreateRunAOs";
import { AOMatchedComponent } from "./AOMatched";
import { AOOnDemandComponent } from "./AOOnDemand";
import { AOReadMatchComponent } from "./AOReadMatch/AOReadMatch";
import { AOReadMatchDetailComponent } from "./AOReadMatch/AOReadMatchDetail";
import { AOReadMatchHtmlComponent } from "./AOReadMatch/AOReadMatchHtml";
import { AOReadMatchResultComponent } from "./AOReadMatch/AOReadMatchResult";
import { FeedbackComponent } from "./Feedback";

export const AORoutes = [
    {
        path: '/aos',
        element: <RunAOsComponent />
    },
    {
        path: '/aos/result/:runId',
        element: <RunAosResultComponent />
    },
    {
        path: '/aos/ao/:aoId',
        element: <GetAOComponent />
    },
    {
        path: '/aos/aohtml/:aoId',
        element: <AOHtmlComponent />
    },
    {
        path: '/aos/matched/:aoId',
        element: <AOMatchedComponent />
    },
    {
        path: '/aos/readmatch',
        element: <AOReadMatchComponent />
    },
    {
        path: '/aos/readmatch/detail/:key',
        element: <AOReadMatchDetailComponent />
    },
    {
        path: '/aos/readmatch/html/:key',
        element: <AOReadMatchHtmlComponent />
    },
    {
        path: '/aos/readmatch/result/:key',
        element: <AOReadMatchResultComponent />
    },
    {
        path: '/aos/ondemand',
        element: <AOOnDemandComponent />
    },
    {
        path: '/aos/ondemand/:appelOffre',
        element: <AOOnDemandComponent />
    },
    {
        path: 'aos/create',
        element: <CreateRunAOsComponent />,
        role: 'Pocahontas_CreateRunAos'
    },
    {
        path: 'aos/feedback/:id',
        element: <FeedbackComponent />,
        role: 'Pocahontas_Feedback'
    },
    {
        path: 'aos/feedback',
        element: <FeedbackComponent />,
        role: 'Pocahontas_Feedback'
    }
];